import {BREAKPOINT} from "./common";

export function init(isVueModal = false): void {

    $(document).on("click", ".share", function (e: JQuery.Event) {
        e.stopPropagation();

        $("#inputUrl").val($(this).data("url"))

        const url = $(this).data("url");
        const title = $(this).data("title");

        const navigatorVar: any = navigator;

        if (navigatorVar.share && window.screen.width < BREAKPOINT.LARGE) {
            navigatorVar.share({
                title: title,
                url: url,
            }).then(() => console.log("Successful share")).catch((error: any) => console.error("Error sharing", error));
        } else {
            const $modalShare = $("#modal-share");

            $modalShare.data("url", url);
            $modalShare.data("title", title);
            !isVueModal && $modalShare.modal("show");
        }
    });

    $("#email-share").click(() => {

        const $modalShare = $("#modal-share");

        const url = $modalShare.data("url") + "?utm_medium=email";
        const title = $modalShare.data("title");

        const text = `${title}\n\n${url}`;

        window.location.href = `mailto:?subject=${title}&body=${encodeURIComponent(text)}`;
    });

    $("#facebook-share").on("click", () => {

        const $modalShare = $("#modal-share");

        const url = $modalShare.data("url") + "?utm_medium=facebook";

        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
            "_blank", "location=yes,height=350,width=600,scrollbars=yes,status=yes");
    });

    $("#whatsapp-share").on("click", () => {

        const $modalShare = $("#modal-share");

        const url = $modalShare.data("url") + "?utm_medium=whatsapp";
        const title = $modalShare.data("title");

        const text = `${title}\n${url}`;

        // eslint-disable-next-line max-len
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`, "_blank", "location=yes,height=350,width=600,scrollbars=yes,status=yes");

    });

    $("#telegram-share").on("click", () => {
        const $modalShare = $("#modal-share");

        const url = $modalShare.data("url") + "?utm_medium=telegram";
        const title = $modalShare.data("title");

        //eslint-disable-next-line max-len
        window.open(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,"_blank", "location=yes,height=350,width=600,scrollbars=yes,status=yes");
    });

    $("#copy-text").on("click", () => {
        const $modalShare = $("#modal-share");

        const url = $modalShare.data("url")

        try {
            navigator.clipboard.writeText(url);
            $("#copySuccess").removeClass("d-none")
        } catch (error) {
            console.error(error);
            $("#copyError").removeClass("d-none")
        } finally {
            delayCloseAlert()
        }
    });

}

export function delayCloseAlert(): void {
    setTimeout(() => {
        $("#copySuccess").addClass("d-none")
        $("#copyError").addClass("d-none")
    }, 500);
}

